var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "button",
        {
          staticClass: "btn btn-light",
          attrs: { disabled: _vm.disabled },
          on: { click: _vm.onclickPrint }
        },
        [_c("i", { staticClass: "fas fa-print" })]
      ),
      _vm._v(" "),
      _c("print-orders", {
        staticClass: "receipt-template",
        staticStyle: {
          position: "fixed",
          "z-index": "-1",
          top: "1mm",
          left: "1mm",
          "font-family": "tahoma",
          color: "black",
          width: "100%"
        },
        attrs: {
          orders: _vm.orders,
          total_price: _vm.totalPrice,
          created_at: _vm.moment().format("D/M/Y H:mm"),
          font_size: _vm.getShopInfo.settings.apps.pos.receipt.font_size
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-516512b8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-516512b8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/pos/sale/mobile/common/PrintButton.vue
// module id = null
// module chunks = 